import i18n from '@/i18n';
import { IconType } from '@/types/components';
import {
  PersonType,
  type ProfileEntryResponse,
  type ProfileIdentity,
  type StudyYearResponse,
  type UserInfoResponse,
} from '@/types/user';
import { getFullName } from '@/utils/text';

export const personTypeIcons: Record<PersonType, IconType> = {
  [PersonType.Mother]: IconType.Mother,
  [PersonType.Father]: IconType.Father,
  [PersonType.OtherResponsiblePerson]: IconType.Father,
  [PersonType.Student]: IconType.Student,
};

export const getRoleLabel = (personType?: PersonType): string =>
  personType ? i18n.t(`roles.${personType}`) : '';

export const getNameWithRole = ({
  person,
  personType,
  lowercaseRole = false,
}: {
  person?: { firstName?: string; lastName?: string };
  personType?: PersonType;
  lowercaseRole?: boolean;
}): string => {
  const roleLabel = getRoleLabel(personType);

  if (!roleLabel) {
    return '';
  }

  return `${getFullName(person)} (${lowercaseRole ? roleLabel.toLowerCase() : roleLabel})`;
};

export const getProfileKey = (identity: ProfileIdentity): string =>
  `${identity.profileId}-${identity.classId}`;

export const isSameProfile = (
  identity: ProfileIdentity,
  otherIdentity: ProfileIdentity,
): boolean =>
  identity.profileId === otherIdentity.profileId &&
  identity.classId === otherIdentity.classId;

export const getStudyYearProfiles = (
  studyYear: StudyYearResponse,
): ProfileEntryResponse[] => [
  ...studyYear.profiles,
  ...(studyYear.inactiveProfiles ?? []),
];

const LOWEST_ADVERTISABLE_LEVEL = 4;

export const isEligibleForAds = (user?: UserInfoResponse): boolean => {
  const isStudent = user?.personType === PersonType.Student;

  return !isStudent || (user?.class?.level ?? 5) > LOWEST_ADVERTISABLE_LEVEL;
};
